module.exports = __webpack_public_path__ + "img/ms-icon-70x70.17a0b95.png";